
// app.module.ts
import { BrowserModule } from '@angular/platform-browser';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { GlobalModule } from './modules/global/global.module';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { MsalModule, MsalRedirectComponent } from '@azure/msal-angular';
import { PublicClientApplication } from '@azure/msal-browser';
import { DatePipe } from '@angular/common';
import { HttpConfigInterceptor } from './modules/shared/services/httpconfig.interceptor';
import { msalConfig, msalGuardConfig, msalInterceptorConfig } from './modules/shared/models/msal-config';
import { FormsModule } from '@angular/forms';
import { ConfirmationModalMarginComponent } from './modules/margin-calculator/components/confirmation-modal-margin/confirmation-modal-margin.component';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { ModalModule } from 'ngx-bootstrap/modal';
import { NgbDropdownModule, NgbPopoverModule } from '@ng-bootstrap/ng-bootstrap';

@NgModule({
  declarations: [
    AppComponent,
    ConfirmationModalMarginComponent
  ],
  imports: [
    FormsModule,
    BrowserModule,
    AppRoutingModule,
    GlobalModule,
    NgbDropdownModule,
    NgbPopoverModule,
    // MSAL Angular v4: instance, guard config, interceptor config
    MsalModule.forRoot(
      new PublicClientApplication(msalConfig),
      msalGuardConfig,
      msalInterceptorConfig
    ),

    NgIdleKeepaliveModule.forRoot(),
    ModalModule.forRoot()
  ],
  providers: [
    DatePipe,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpConfigInterceptor,
      multi: true
    }
    // ⬅️ APP_INITIALIZER removed because MsalRedirectComponent handles init for redirect flows
  ],
  // MSAL redirects are handled by this dedicated component
  bootstrap: [AppComponent, MsalRedirectComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule { }